// Names shown for explanation-video presenters, voice providers and board designs.
// Used by Settings → Videos and the per-run style picker on the Explanation Videos page.

export const TUTOR_LABELS = {
  anime_mix: "3D anime, mixed per question",
  shino: "3D anime: Shino (girl, long black hair, uniform)",
  fumiriya: "3D anime: Fumiriya (boy, uniform)",
  shibu: "3D anime: Shibu (girl, short hair, uniform)",
  bibi: "3D anime: Bibi (girl, brown bob, green dress)",
  vita: "3D anime: Vita (girl, white hair, sci-fi outfit)",
  victoria: "3D anime: Victoria (girl, blonde, pink dress)",
  robot: "3D robot (animated)",
  mix: "Doodle tutors, mixed per question",
  sam: "Doodle: Sam (boy)",
  maya: "Doodle: Maya (girl)",
  leo: "Doodle: Leo (boy)",
  ava: "Doodle: Ava (girl)",
};

export const DRIVER_LABELS = {
  google: "Google WaveNet (default, British voices, 4M characters free a month)",
  grok: "xAI Grok (American voices, ~¼ of OpenAI's price)",
  openai: "OpenAI",
  azure: "Microsoft Azure (British neural voices)",
  gemini: "Google Gemini (style-prompted voices)",
};

export const THEME_LABELS = {
  classic: "Classic (light wall, grey frame)",
  chalkboard: "Chalkboard (green wall, wooden frame)",
  pastel: "Pastel (pink wall, lilac frame)",
  night: "Night (navy wall, slate frame)",
};

/** Girl and boy voice lists offered for a provider, from the video-settings options. */
export function voiceListsFor(driver, options) {
  switch (driver) {
    case "grok":
      return [options.grok_female_voices || [], options.grok_male_voices || []];
    case "google":
      return [options.google_female_voices || [], options.google_male_voices || []];
    case "gemini":
      return [options.gemini_female_voices || [], options.gemini_male_voices || []];
    case "azure":
      return [options.azure_voices || [], options.azure_voices || []];
    case "openai":
      return [["auto", ...(options.openai_female_voices || [])], ["auto", ...(options.openai_male_voices || [])]];
    default:
      return [[], []];
  }
}

/** "Shino · Grok ara · Chalkboard · music" — a short summary of a run style. */
export function describeStyle(style) {
  if (!style) return "";
  const parts = [];
  if (style.tutor) parts.push((TUTOR_LABELS[style.tutor] || style.tutor).replace(/^(3D anime|Doodle): /, "").replace(/ \(.*$/, ""));
  if (style.driver) parts.push([style.driver, style.voice_female, style.voice_male].filter(Boolean).join(" "));
  if (style.board_theme) parts.push(style.board_theme);
  if (style.music_enabled !== undefined && style.music_enabled !== null) parts.push(style.music_enabled ? "music" : "no music");
  return parts.join(" · ");
}
